<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M6.233 25.878L16 6.52l9.767 19.358H6.233zm8.29-20.942a1.632 1.632 0 012.953 0L27.801 25.4c.594 1.178-.213 2.6-1.476 2.6H5.675c-1.263 0-2.07-1.422-1.476-2.6L14.524 4.936zM16.2 20.704c.283 0 .516-.192.53-.436l.357-6.145c.016-.262-.226-.482-.53-.482h-1.113c-.304 0-.546.22-.53.483l.364 6.144c.014.244.248.436.53.436h.392zm-.2 2.62c.601 0 1.088-.459 1.088-1.025 0-.566-.487-1.025-1.087-1.025-.601 0-1.088.459-1.088 1.025 0 .566.487 1.025 1.088 1.025z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'symbolsAlertOutline'
}
</script>
